export const START_UPDATE_REGION_SETTINGS = "START_UPDATE_REGION_SETTINGS";
export const START_UPDATE_REGION_SETTINGS_PER_USER = "START_UPDATE_REGION_SETTINGS_PER_USER";
export const UPDATE_REGION_SETTINGS_FAILED = "UPDATE_REGION_SETTINGS_FAILED";
export const UPDATE_REGION_SETTINGS_PER_USER_FAILED = "UPDATE_REGION_SETTINGS_PER_USER_FAILED";
export const UPDATE_REGION_SETTINGS_PER_USER_SUCCESS = "UPDATE_REGION_SETTINGS_PER_USER_SUCCESS";
export const UPDATE_REGION_SETTINGS_SUCCESS = "UPDATE_REGION_SETTINGS_SUCCESS";
